import { NgModule } from '@angular/core';
import { TvfRoutingModule } from './tvf-routing.module';
import { TvfComponent } from './tvf.component';
import { SharedModule } from '../shared/shared.module';
import { TVF_SERVICE, TvfRequestsService } from './services/tvf-requests.service';
import { AccessControlModule } from '../core/access-control/access-control.module';
import { RetailersModule } from './retailers/retailers.module';
import { QualityControlModule } from './quality-control/quality-control.module';
import { LmrModule } from './lmr/lmr.module';
import { StockEntryModule } from './stock-entry/stock-entry.module';

@NgModule({
  declarations: [TvfComponent],
  imports: [
    TvfRoutingModule,
    SharedModule,
    AccessControlModule,
    RetailersModule,
    LmrModule,
    QualityControlModule,
    StockEntryModule,
  ],
  providers: [
    {
      provide: TVF_SERVICE,
      useClass: TvfRequestsService,
    },
  ],
})
export class TvfModule {}
